import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import moment from 'moment';

import testSched_9Day_num1 from '../Components/Schedule/SevenNineDay/utils/test-data/test-data-nine';


export async function getDetailedSchedule(startDate, endDate, resourceId, userId) {
  let detailedScheduleArray = await API.graphql(graphqlOperation(
    queries.scheduleApIgetDetailedSchedules,
    {
      startDate,
      endDate,
      resourceId,
      userId
    }
  ));

  let detailedScedules = detailedScheduleArray.data.scheduleAPIgetDetailedSchedules.detailedSchedule;

  let filteredDetailedSchedules = detailedScedules.filter((dayType) => {
    return moment.unix(dayType.timeStart).isBefore(moment(endDate, 'YYYYMMDD').endOf('day'));
  })

  // console.log(detailedScedules);
  // console.log(filteredDetailedSchedules);

  const detailedSchedule = {
    startDate,
    endDate,
    detailedSchedules: filteredDetailedSchedules
  };

  return detailedSchedule;
}



// WEBPACK FOOTER //
// ./src/api/detailedScheduleApi.js